var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAccessUnavailable = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.56 19.954 19.925 5.669l.705.71L6.266 20.662z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13 23.531C7.194 23.531 2.469 18.807 2.469 13S7.194 2.469 13 2.469 23.532 7.193 23.532 13 18.807 23.531 13 23.531m0-20.062c-5.256 0-9.531 4.275-9.531 9.531S7.744 22.531 13 22.531s9.531-4.275 9.531-9.531S18.256 3.469 13 3.469"
})));
export default SvgAccessUnavailable;